/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */
import SockJS from 'sockjs-client';
import Stomp from 'stomp-websocket';
// import helper from 'util/helpers'
import eventBus from '../../../EventBus';
const ticketURL = process.env.TICKET_URL; // http://localhost:38180

const getDefaultState = () => {
  // 1개의 티켓브랜드만 구독하기 위해서, 배열 형태가 아닌 그냥 변수에 저장한다.
  return {
    stompClient: null,
    isTicketConnecting: false,
    isTicketSocketConnected: false,
    currentSubscription: null
  };
};
const state = getDefaultState();

const getters = {
  IS_TICKET_CONNECTED: (state) => {
    return state.isTicketSocketConnected;
  }
};
const mutations = {
  START_TICKET_CONNECT(state) {
    state.isTicketConnecting = true;
  },
  END_TICKET_CONNECT(state) {
    state.isTicketConnecting = false;
    state.isTicketSocketConnected = true;
    state.stompClient.connected = true;
    return true;
  },
  FAIL_TICKET_CONNECT(state) {
    state.isTicketConnecting = false;
    state.isTicketSocketConnected = false;
    state.stompClient.connected = false;
  },

  ticketSubScribe(state, payload) {
    let subscription = (state.currentSubscription = state.stompClient.subscribe(
      payload.subscribeUrl,
      (tick) => payload.callBack(JSON.parse(tick.body)),
      {}
    ));

    state.subscription = {
      subscriptionUrl: payload.subscribeUrl,
      id: subscription.id,
      subscription: subscription
    };
  },
  forceTicketCloseSubscription(state) {
    if (state.subscription) {
      state.subscription.subscription.unsubscribe();
    } else {
      console.log('연결되어있는 티켓 소켓이 없습니다.');
    }
  }
};

const actions = {
  async ticket_connect({ commit, state }) {
    commit('START_TICKET_CONNECT');
    state.stompClient = Stomp.over(new SockJS(ticketURL + '/api/ticket/webSocket', null, { transports: 'websocket', timeout: 1000 }));
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null;
    }
    state.stompClient.connect(
      {},
      (frame) => {
        commit('END_TICKET_CONNECT');
        eventBus.$emit('ticket-socket-connection-success');
        return true;
      },
      (error) => {
        commit('forceTicketCloseSubscription');
        commit('FAIL_TICKET_CONNECT');
        eventBus.$emit('ticket-reconnect-start');
      }
    );
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/ticketWebSocket/index.js